import { SxProps } from "@mui/material";
import { StatusPicker, IssueStatusChangedDialogContent, useDialog } from "src/components";
import { ClosedIssueStatuses, DEFAULT_TASK_ITEM_STATUS, IssueStatus, ISSUE_STATUSES } from "src/constants";
import { useEditIssueStatus } from "src/http";

interface IProps {
  variant: "button" | "select";
  issueGuid?: string;
  status: IssueStatus;
  teamSlug?: string;
  createdByUserGuid?: string;
  disabled?: boolean;
  sx?: SxProps;
}

const IssueStatusPicker = (props: IProps) => {
  const { mutate: editIssueStatus } = useEditIssueStatus();
  const { showDialog, closeDialog } = useDialog();

  async function handleStatusChanged(newSelectedStatus: IssueStatus) {
    if (props.issueGuid === undefined || props.createdByUserGuid === undefined) {
      return;
    }

    if (newSelectedStatus !== IssueStatus.Open) {
      showDialog({
        content: (
          <IssueStatusChangedDialogContent
            issueGuid={props.issueGuid}
            status={newSelectedStatus}
            onDone={closeDialog}
          />
        ),
      });
    }

    await editIssueStatus({
      issueGuid: props.issueGuid,
      statusId: newSelectedStatus,
      teamSlug: props.teamSlug,
      createdByUserId: props.createdByUserGuid,
    });
  }

  return (
    <StatusPicker
      variant={props.variant}
      disabled={props.disabled}
      value={props.status ?? DEFAULT_TASK_ITEM_STATUS}
      options={ISSUE_STATUSES.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : 0))}
      groupBy={(option) => (ClosedIssueStatuses.includes(option.id) ? "Closed Statuses" : "Active Statuses")}
      onChange={handleStatusChanged}
      sx={{ ...props.sx }}
    />
  );
};

export { IssueStatusPicker };
